<template>
<div class="grxinxi">
    <div class="grxinxi-cont">
        <div class="grthree-zpxinxi-title"><i></i> <span>账户信息</span></div>

        <!-- 上传个人信息 -->
        <div class="gerenxinxi-all">
            <!-- 头像上传 -->
            <div class="gerenxinxi-all-rlogo">
                <span>个人头像</span>
                <div class="gerenxinxi-all-rlogo-up">
                    <el-upload
  class="avatar-uploader"
  :action="beforup"
  :show-file-list="false"
  :on-success="handleAvatarSuccess"
 :before-upload="beforUploadgr"
  accept=".jpg,.jpeg,.png,.gif"
  >
   <!-- :before-upload="beforeAvatarUpload"上传前钩子函数 -->
  <img v-if="imageUrl"  :src="imageUrl" class="avatar">
  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
</el-upload>


                </div>
            </div>
            <!-- 用户名称 -->
            <div class="gernxinxi-all-rname">
                <span>账户名称</span>
                <div class="gernxinxi-all-rname-inp">
                <el-input :disabled='true' placeholder="个人姓名" v-model="grname" ></el-input>
                </div>
            </div>
            <!-- 账号原密码和新密码和个人说明 -->
            <div class="gerenxinxi-all-psword">

                <div class="gerenxinxi-all-mima">

                <!-- 新密码 -->
                <div class="gerenxinxi-all-psword-new">
                     <span>账号新密码</span>
                    <div class="gerenxinxi-all-psword-newinp">
                        <el-input placeholder="账号新密码" v-model="grnewpsword" show-password></el-input>
                    </div>
                </div>

                </div>
                <!-- 个人说明 -->
                <div class="gerenxinxi-all-explain">
                     <el-input
            type="textarea"
            placeholder="个人说明..."
            v-model="gerenxinxitext"
            maxlength="80"
            show-word-limit
            :rows="5"
            resize="none"

          >
          </el-input>
                </div>

            </div>
            <!-- 保存信息 -->
            <div @click="btnpost" class="gerenxinxi-btnok">
                <span>保存信息</span>
            </div>
        </div>

    </div>

</div>
</template>

<script>
import GeRenxinxi from '../css/GeRenxinxi.css'
import axios from 'axios'
export default {
data(){
    return{
        grname:'',
        grbeforepsword:'',
        grnewpsword:'',
        gerenxinxitext:JSON.parse(localStorage.getItem("grxinxi")).message,
        imageUrl:'',
        urlpost:this.$apiUrl+'/index.php/user/editAccount',
        tokens:JSON.parse(localStorage.getItem("userinfo")).token,
        files:'',
        morenImg:'',
        mologo:true,
        beforup:this.$apiUrl+'/index.php/index/upload',
        // hedimg:''
    }
},
mounted () {
  this.xinxipush();
      this.imageUrl ='http://ke.yunlearning.com:8081'+JSON.parse(localStorage.getItem("grxinxi")).head_img;


},

 methods: {

      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
        // console.log(this.imageUrl,'这是图片地址')

      },
      beforUploadgr(file) {

        // this.mologo = false;
        this.files = file;
        const isimg = file.type === 'image/jpeg' ||
        file.type === "image/JPG" ||
        file.type === "image/png" ||
        file.type === "image/PNG" ||
        file.type === "image/jpg";
        // const isPNG = file.type === 'image /png';
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isimg) {
          this.$message.error({
            message:'请上传 JPG或PNG 格式的图片!',
            offset:200
          });
        }

        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isimg &&  isLt2M;
        // isJPG &&
      },
      // 个人信息
      xinxipush(){

if (this.tokens=='') {
  this.$message.error({
    message:'请重新登录',
    offset:200
  })
  this.$router.push({path:"/denglu"});
  localStorage.clear();
}else if (this.tokens && JSON.parse(localStorage.getItem("userinfo")).type == 1) {
  this.grname =  JSON.parse(localStorage.getItem("grxinxi")).nickname;
}else if (this.tokens && JSON.parse(localStorage.getItem("userinfo")).type == 2) {
   this.grname = JSON.parse(localStorage.getItem("grxinxi")).name;
}


      },
      // 修改信息
 btnpost(){

  let fa = new window.FormData;

fa.append('head_img',this.files);

  fa.append('name',this.grname);
  fa.append('token',this.tokens);
  fa.append('message',this.gerenxinxitext);
  fa.append('password',this.grnewpsword);
  fa.append('nickname',this.grname);
axios({
  method: 'post',
  url: this.urlpost,
 data: fa
}).then(res=>{

    //  this.$message({
    //    message:res.data.msg,
    //    offset:200,
    //    type:'success'
    //  });
  if (res.data.code == 1 && this.grnewpsword=='') {
    this.$message({
      message:res.data.msg,
      offset:200,
       type:'success'
    });
    this.$router.go(0);
    return false
  }else if (res.data.code == 1 && this.grnewpsword !=='') {
      this.$message({
      message:'密码已修改，请重新登录！！！',
      offset:200
    });
    localStorage.clear();
    this.$router.push({path:'/denglu'});
  }
}).catch(error=>{
  console.log(error);
})

  }
 },
 computed:{
 staimg(){
      return this.$store.state.grxinxi
    }
},
}
</script>

<style>
.avatar-uploader .el-upload {
     border: 1px dashed #d9d9d9;
     border-radius: 0.06rem;
     cursor: pointer;
     position: relative;
     overflow: hidden;
}
 .avatar-uploader .el-upload:hover {
     border-color: #409EFF;
}
 .avatar-uploader-icon {
     font-size: 0.28rem;
     color: #8c939d;
     width: 1.31rem;
     height: 1.14rem;
     line-height: 1.14rem;
     text-align: center;
}
 .avatar {
     width: 1.22rem;
     height: 1.14rem;
     display: block;
}
 .gerenxinxi-all-rlogo-up{
     width: 1.31rem;
     height: 1.14rem !important;
     position: relative;
}


</style>



// WEBPACK FOOTER //
// src/components/GeRenxinxi.vue